/* SnapTint per-square-foot calculator for sections/st-sqft-product.liquid.
   Each window size -> one cart line, quantity = ceil(w * h / 144) square feet x pieces ("How many": Liu Qiang's QA, Harrison
   2026-10-01, so ten identical pieces are one line), properties: width, height, shape, exact area, pieces. */
(function () {
  var form = document.querySelector('[data-st-sqft]');
  if (!form) return;
  var cfg = JSON.parse(document.querySelector('[data-st-sqft-config]').textContent);
  var rows = form.querySelector('[data-st-windows]');
  var tpl = document.querySelector('[data-st-row]');
  var money = function (cents) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cfg.currency || 'USD' }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); } };

  // shade picker: show the chosen shade's simulated image (variant featured media); shades without one show the supplier photo
  var shadeSel = form.querySelector('select[name="variant"]'), mainImg = document.querySelector('[data-st-main]');
  if (shadeSel && mainImg) {
    var showShade = function () {
      var o = shadeSel.options[shadeSel.selectedIndex], src = o.dataset.img || mainImg.dataset.defaultSrc;
      if (mainImg.getAttribute('src') !== src) mainImg.src = src;
      mainImg.alt = o.dataset.img ? (o.dataset.alt || '') : (mainImg.dataset.defaultAlt || '');
      var pv = document.querySelector('[data-st-preview]');
      if (pv) {
        pv.dataset.curImg = o.dataset.img || '';
        var ft = pv.querySelector('[data-st-film-tag]');
        ft.textContent = '';   // two lines: film name, then the shade word
        if (o.dataset.line) {
          var n = document.createElement('span'); n.className = 'st-sq__tag-name'; n.textContent = o.dataset.line; ft.appendChild(n);
          if (o.dataset.desc) { var d = document.createElement('span'); d.className = 'st-sq__tag-shade'; d.textContent = o.dataset.desc; ft.appendChild(d); }
        }
        tags(!!(o.dataset.img && o.dataset.line));
      }
    };
    shadeSel.addEventListener('change', showShade);
    showShade();   // also after Back: the browser may restore a different shade than the page rendered
  }
  // film label over the preview: only while the big image is the chosen shade's simulation
  function tags(on) {
    var pv = document.querySelector('[data-st-preview]');
    if (!pv) return;
    pv.querySelectorAll('[data-st-film-tag], [data-st-clear-tag]').forEach(function (t) { t.hidden = !on || !pv.querySelector('[data-st-film-tag]').textContent; });
  }
  document.querySelectorAll('[data-st-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      // a shade's thumbnail selects that shade (image, label and price follow the menu)
      var sel = form.querySelector('select[name="variant"]');
      if (b.dataset.stVariant && sel) { sel.value = b.dataset.stVariant; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
      document.querySelector('[data-st-main]').src = b.dataset.stThumb;
      var pv = document.querySelector('[data-st-preview]');
      if (pv) tags(!!pv.dataset.curImg && pv.dataset.curImg === b.dataset.stThumb);
    });
  });

  function variantEl() { var s = form.elements.variant; return s.tagName === 'SELECT' ? s.options[s.selectedIndex] : s; }
  function rate() { return +variantEl().dataset.price; }
  function addRow() {
    rows.appendChild(tpl.content.cloneNode(true));
    update();
  }
  function measure(row) {
    var w = parseFloat(row.querySelector('[name="w"]').value), h = parseFloat(row.querySelector('[name="h"]').value);
    if (!(w > 0 && h > 0)) return null;
    var exact = w * h / 144;
    var n = parseInt(row.querySelector('[name="n"]').value, 10);   // pieces of this size; blank or 0 counts as 1
    n = n >= 1 ? Math.min(n, 100) : 1;
    // the cutter takes film up to 46 in wide (Qiang 2026-10-02): a piece with both sides over 46 in ships uncut, for the
    // customer to trim; the shorter side is laid across the roll, so one side over 46 in is fine
    var uncut = Math.min(w, h) > 46;
    return { w: w, h: h, exact: exact, sqft: Math.max(1, Math.ceil(exact - 1e-9)), n: n, uncut: uncut, shape: row.querySelector('[name="shape"]').value };
  }
  function update() {
    var total = 0, area = 0;
    rows.querySelectorAll('.st-window').forEach(function (row) {
      var m = measure(row);
      row.querySelector('[data-st-rowarea]').textContent = m ? (m.n > 1 ? m.n + ' × ' + m.sqft + ' sq ft' : m.sqft + ' sq ft') : '–';
      var note = row.querySelector('[data-st-rownote]');
      if (note) note.hidden = !(m && m.uncut);
      if (m) { area += m.sqft * m.n; total += m.sqft * m.n * rate(); }
      row.querySelector('[data-st-remove]').hidden = rows.children.length === 1;
    });
    if (form.elements.tools && form.elements.tools.checked) total += cfg.toolsPrice;
    var rateEl = document.querySelector('[data-st-rate]');
    if (rateEl) rateEl.textContent = money(rate());
    form.querySelector('[data-st-area]').textContent = area + ' sq ft';
    form.querySelector('[data-st-total]').textContent = money(total);
  }

  // analytics: sqft_calculated once the total settles (1 s), once per distinct total; sqft_add_to_cart on submit
  var track = function (n, d) { if (window.stTrack) window.stTrack(n, d); };
  var handle = location.pathname.split('/').pop(), lastCalc = '', calcT = null;
  function calcData() {
    var n = 0, sq = 0;
    rows.querySelectorAll('.st-window').forEach(function (row) { var m = measure(row); if (m) { n += m.n; sq += m.sqft * m.n; } });
    var o = variantEl();
    return { product: handle, windows: n, sqft_total: sq, value: Math.round(sq * rate()) / 100, shade: o.textContent ? o.textContent.trim() : '' };
  }
  form.addEventListener('input', function () {
    clearTimeout(calcT);
    calcT = setTimeout(function () {
      var d = calcData(), key = d.windows + '|' + d.sqft_total + '|' + d.shade;
      if (!d.sqft_total || key === lastCalc) return;
      lastCalc = key; var e = { product: d.product, windows: d.windows, sqft_total: d.sqft_total, value: d.value };
      track('sqft_calculated', e);
    }, 1000);
  });
  form.addEventListener('input', update);
  form.addEventListener('change', update);
  form.addEventListener('click', function (e) {
    if (e.target.closest('[data-st-addrow]')) addRow();
    var rm = e.target.closest('[data-st-remove]');
    if (rm) { rm.closest('.st-window').remove(); update(); }
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var err = form.querySelector('[data-st-error]');
    var items = [], bad = false, notes = form.elements.notes.value.trim();
    rows.querySelectorAll('.st-window').forEach(function (row, i) {
      var m = measure(row);
      if (!m) { bad = true; return; }
      var props = { 'Window': String(i + 1), 'Width (in)': String(m.w), 'Height (in)': String(m.h), 'Shape': m.shape,
                    'Exact area (sq ft)': m.exact.toFixed(2), 'Pieces': String(m.n) };
      if (m.uncut) props['Cut'] = 'Ships uncut (both sides over 46 in), customer trims';
      if (notes) props['Instructions'] = notes;
      items.push({ id: +variantEl().value, quantity: m.sqft * m.n, properties: props });
    });
    if (bad || !items.length) { err.textContent = 'Enter a width and height for every window.'; err.hidden = false; return; }
    err.hidden = true;
    if (form.elements.tools && form.elements.tools.checked && cfg.tools) items.push({ id: cfg.tools, quantity: 1 });
    var btn = form.querySelector('[data-st-add]');
    btn.disabled = true;
    track('sqft_add_to_cart', calcData());
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); location.href = '/cart'; })
      .catch(function () { btn.disabled = false; err.textContent = 'Could not add to cart. Please try again.'; err.hidden = false; });
  });
  addRow();
})();
